import { token } from '@bynder/design-system';
import styled from 'styled-components';
import { device, VISUALS } from '../../constants/styles';

export const LogoContainer = styled.div`
  width: auto;
  height: auto;
  max-height: 60px;
  line-height: 60px;
  margin: 0;
  border-radius: 0;
`;

export const Logo = styled.img`
  max-height: 50px;
  margin: 0;
  vertical-align: middle;
  transition: none;
`;

export const StyledPreviewContainer = styled.div<{ $backgroundColor: string }>`
  background-color: ${props => props.$backgroundColor};
  padding-left: 26px;
  margin-top: 16px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 200px;
  width: 100%;
  border-radius: ${token.radiusLarge};
  box-shadow: ${token.elevation4};
`;

export const PreviewContainer = styled.div`
  border-radius: ${token.radiusLarge};
  padding: ${token.spacing7};
  background-color: ${token.gray25a};
  top: calc(
    ${VISUALS.THEMESET_HEADER_HEIGHT} + ${token.spacing5} +
      ${VISUALS.BYNDER_HEADER_HEIGHT}
  );
  @media ${device.laptop} {
    width: 300px;
  }
  @media ${device.laptopL} {
    width: 600px;
  }
  @media ${device.desktop} {
    width: 800px;
  }
  @media ${device.desktopL} {
    width: 1000px;
  }
`;
